"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _atoms = require("../../../atoms");

var _molecules = require("../../../molecules");

var _intl = require("../../../intl");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StartAdornment = /*#__PURE__*/(0, _styledComponents["default"])(_core.InputAdornment).withConfig({
  displayName: "RateCardDefaultSettingInput__StartAdornment"
})(["", ""], function (_ref) {
  var typography = _ref.theme.typography;
  return (0, _styledComponents.css)(["margin:0 0 ", " ", ";"], typography.pxToRem(6), typography.pxToRem(6));
});

var NumberInput = function NumberInput(props) {
  return _react["default"].createElement(_molecules.NumberInput, _extends({
    allowNegative: props.allowNegative || false,
    decimalScale: props.decimalScale || 2,
    size: props.size || 'small'
  }, props));
};

var RateCardDefaultSettingInput = function RateCardDefaultSettingInput(_ref2) {
  var value = _ref2.value,
      input = _ref2.input,
      handleChange = _ref2.handleChange,
      currencySymbol = _ref2.currencySymbol,
      numberInputProps = _ref2.numberInputProps,
      handleRateMarkupChangeOverride = _ref2.handleRateMarkupChangeOverride;
  var handlePaymentDaysChange = (0, _react.useCallback)(function (newValue) {
    handleChange({
      paymentDays: newValue.floatValue
    });
  }, [handleChange]);
  var handleRateChange = (0, _react.useCallback)(function (newValue) {
    handleChange({
      rate: newValue.floatValue
    });
  }, [handleChange]);
  var handleRateMarkupChange = (0, _react.useCallback)(function (newValue) {
    //HandleRateMarkupChangeOverride was added because
    //we need a default value for the rateMarkup input of the global RateCardDefaultSetting component
    //but we don't want to put this business logic in Lego's, this is why it's moved to the WebApp
    var updatedValue = handleRateMarkupChangeOverride ? handleRateMarkupChangeOverride(newValue.floatValue) : newValue.floatValue;
    handleChange({
      rateMarkup: updatedValue
    });
  }, [handleChange]);
  var labels = {
    rate: 'ratecard.form.rate',
    rateMarkup: 'ratecard.defaultSettings.rateMarkup',
    paymentDays: 'ratecard.defaultSettings.paymentDays'
  };
  var tooltipText = {
    rate: 'ratecard.defaultSettings.tooltipRate',
    rateMarkup: 'ratecard.defaultSettings.tooltipRateMarkup',
    paymentDays: 'ratecard.defaultSettings.tooltipPaymentDays'
  };
  var changeHandlers = {
    rate: handleRateChange,
    rateMarkup: handleRateMarkupChange,
    paymentDays: handlePaymentDaysChange
  };
  var adornmentsComponents = {
    rate: {
      prefix: currencySymbol
    },
    rateMarkup: {
      suffix: '%'
    },
    paymentDays: {}
  };
  return _react["default"].createElement(_core.Grid, {
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "center",
    spacing: 1
  }, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 11
  }, _react["default"].createElement(_core.FormControl, {
    fullWidth: true
  }, _react["default"].createElement(NumberInput, _extends({
    label: _react["default"].createElement(_intl.IntlMessage, {
      ident: labels[input]
    }),
    onValueChange: changeHandlers[input],
    value: value
  }, adornmentsComponents[input], numberInputProps)))), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 1
  }, _react["default"].createElement(_molecules.Tooltip, {
    placement: "right-start",
    variant: "light",
    title: _react["default"].createElement(_core.Typography, {
      variant: "body1"
    }, _react["default"].createElement(_intl.IntlMessage, {
      ident: tooltipText[input]
    }))
  }, _react["default"].createElement(_atoms.Icon, {
    color: "action",
    fontSize: "small",
    prefix: "fas",
    icon: "info-circle"
  }))));
};

RateCardDefaultSettingInput.propTypes = {
  value: _propTypes["default"].number,
  input: _propTypes["default"].oneOf(['rate', 'rateMarkup', 'paymentDays']).isRequired,
  handleChange: _propTypes["default"].func.isRequired,
  currencySymbol: _propTypes["default"].string
};
var _default = RateCardDefaultSettingInput;
exports["default"] = _default;